import { defineNuxtPlugin } from '#app'
import VueDOMPurifyHTML from 'vue-dompurify-html'

export default defineNuxtPlugin((nuxtApp) => {
  // Basic usage
  nuxtApp.vueApp.use(VueDOMPurifyHTML)

  // Or customize config
  /*
  nuxtApp.vueApp.use(VueDOMPurifyHTML, {
    default: {
      ADD_TAGS: ['iframe'],  // allow iframes
      ADD_ATTR: ['allow', 'allowfullscreen', 'frameborder', 'scrolling']
    }
  })
  */
})
